import $http from '../utils/http'

// 查询当前车的订单记录
export const getUrlLink = (params) => {
  return $http.request({
    url: `/roadparking/smsUrlConfig/getSmsUrlByCode`,
    method: 'get',
    params
  })
}

// 新增留言
export const addMessage = (data) => {
  return $http.request({
    url: `/system/leave/message`,
    method: 'post',
    data
  })
}

// 获取新闻列表
export const getNewsList = (params) => {
  return $http.request({
    url: `/system/news/Information/list`,
    method: 'get',
    params
  })
}

// 获取新闻详情
export const getNewsDetail = (id) => {
  return $http.request({
    url: `/system/news/Information/${id}`,
    method: 'get',
  })
}

// 获取资料列表
export const getInformationList = (params) => {
  return $http.request({
    url: `/resource/websiteInformation/list`,
    method: 'get',
    params
  })
}

